export default __webpack_public_path__ + "static/media/gary.7c7ed849.png";